module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAsYAAAAICAMAAADNy8lqAAAAPFBMVEVHcEz/hQv7gQr6gAr6gAr6gAr7gAr/qir7gQr6gAr7gAr6gAr6gAr/ggv/ggv7gQr7gAr6gAr6gAr7gAuDiwvOAAAAFHRSTlMALJDV8/+PBpb9lb++Ky2Ukb3Wias5rNgAAAB8SURBVHgB7ciFscUwDETRa1Qchv5r/Rgq4Wlm16A9AiDElEvJubzy+ZblnGrgP9a1v3VK5YoXy3LrDcCGc13rWWTZk0cDuhNtmtpZZdmTO5ivvsByVln25DaznnUzsO2ELHtyZP+bbTEAW1qRZW9OHCnnVCfOTFWWvfn4BnOldH8MHSusAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/change-icon/f5_coupon@2x.png
// module id = idTU
// module chunks = 0